import { useEffect, useState } from "react";
import CourseService from "../../APIService/CourseService";
import { CourseLayer } from "../../components/course/CourseLayer";
import { CourseName } from "../../components/course/courseName";
import ExamHeader from "../../components/course/ExamHeader";
import { CourseTypeEnum } from "../../enums";
import { useCourseContext } from "../../context/courseContext";
import {
  setDocumentTitle,
  useSiteNameContext,
} from "../../context/siteNameContext";
import { Button } from "../../shared/button";
import Loading from "../../shared/loading";
import { Scroller } from "../../shared/scroller";
import { Sticker } from "../../shared/sticker";
import { TCourseThemes } from "../../types";

export function ExamPage() {
  const { siteNameList } = useSiteNameContext();
  setDocumentTitle(siteNameList, "exam");

  const ctx = useCourseContext();
  const { coursesList, setCoursesList } = ctx;

  useEffect(() => {
    const fetchCourses = async () => {
      const response = await CourseService.getCourseGroupList({
        courseType: CourseTypeEnum.EXAM!,
        take: 150,
        page: 0,
      });
      if (response && response.data) {
        setCoursesList(response.data);
      }

      setIsCoursesLoading(false);
    };
    fetchCourses().then();
  }, [setCoursesList]);

  const [isCoursesLoading, setIsCoursesLoading] = useState<boolean>(true);

  return (
    <div>
      <ExamHeader />

      {isCoursesLoading ? (
        <Loading />
      ) : (
        <div className="Wrapper">
          <div id={"schoolsWrapper"}>
            {coursesList.map((x: TCourseThemes) => (
              <CourseName
                key={x.shortName || x.name}
                header={x.shortName || x.name}
              />
            ))}
          </div>

          <div
            style={{
              padding: "5%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src={"/images/arrowdown.png"} alt={""} />
          </div>

          <div
            style={{ display: "flex", flexDirection: "column", gap: "2rem" }}
          >
            {coursesList.length === 0 ? (
              <div>
                <p>Нет задач!</p>
              </div>
            ) : (
              coursesList.map((x: TCourseThemes) => (
                <CourseLayer
                  key={CourseTypeEnum.EXAM + (x.shortName || x.name)}
                  courseType={CourseTypeEnum.EXAM!}
                  header={x.shortName || x.name || ""}
                  courses={x.course}
                />
              ))
            )}
          </div>

          <Sticker>
            <Scroller scrollToComponentName={"schoolsWrapper"}>
              <Button>Вернуться к перечню тем</Button>
            </Scroller>
          </Sticker>
        </div>
      )}
    </div>
  );
}
